export default {
  data() {
    return {};
  },
  methods: {
    // 验证手机号前缀
    validatePhone(rule, value, callback) {
      if (value) {
        // 手机号存在时
        if (this.dataForm.phone.prefix) {
          // 前缀存在
          callback();
        } else {
          // 前缀不存在，给出提示
          callback(new Error("Please select the prefix of the mobile phone number"));
        }
      } else {
        // 手机号不存在
        callback();
      }
    },
    // 验证representative(主体代表)手机号前缀
    validateRepresentativePhone(rule, value, callback) {
      if (value) {
        if (this.dataForm.representativeInfo.phone.prefix) {
          callback();
        } else {
          callback(new Error("Please select the prefix of the mobile phone number"));
        }
      } else {
        callback();
      }
    },
    // 验证是否成年
    validateComeAge(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        let birthDaySecond = new Date(value).getTime();
        //获取当前时间
        let atNowDate = new Date().getTime();
        let age = (atNowDate - birthDaySecond) / (365 * 24 * 3600 * 1000);
        if (age < 18) {
          callback(new Error("Must be at least 18 years old"));
        } else {
          callback();
        }
      }
    },
    // 验证输入的值在0~100之间
    validateWithinZeroToHundred(rule, value, callback) {
      if (value) {
        const num = Number(value);
        if (num < 0 || num > 100) {
          return callback(new Error("The number entered cannot be less than 0 or greater than 100"));
        } else {
          return callback();
        }
      }
    },
    // 校验密码
    validatePassword(rule, value, callback) {
      if (!/\S/.test(value)) {
        callback(new Error("Please provide your password"));
      } else {
        callback();
      }
    },
    // 校验确认密码
    validateComfirmPassword(rule, value, callback) {
      if (!/\S/.test(value)) {
        callback(new Error("Please confirm your password"));
      } else if (this.accountForm.password !== value) {
        callback(new Error("Passwords do not match"));
      } else {
        callback();
      }
    },
    // 检验选择日期时间: 必须晚于当前时间 (兼容 "yyyy-MM-dd HH:mm:ss" 字符串与 Date 对象)
    validateFutureTime(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        // 空格分隔的时间串 (如 2026-08-21 14:30:00) 在 Safari 下无法解析, 需转为 "T" 分隔
        const val = typeof value === "string" ? value.replace(" ", "T") : value;
        if (new Date(val).getTime() <= Date.now()) {
          callback(new Error("The selected time must be later than now"));
        } else {
          callback();
        }
      }
    },
  },
};
